import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'metal-silver text-blue-950 border border-slate-400 shadow-lg shadow-black/30 transition-[filter,transform] hover:brightness-110 active:scale-[0.98]',
    secondary: 'bg-blue-950 text-white border border-slate-300/40 shadow-md transition-colors hover:bg-blue-900',
    outline: 'border-2 border-slate-300 bg-transparent text-slate-100 transition-colors hover:bg-white/10'
  };
  const sizes = {
    sm: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-4 text-sm sm:px-8 sm:text-base'
  };
  const classes = `inline-flex items-center justify-center gap-2 rounded-lg font-extrabold uppercase tracking-wide duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-slate-300/60 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-261" data-mp="onkh37ndfgff">
        {children}
        {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-262" data-mp="12madel2d9c2q" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-263" data-mp="xnquktj2kgel">
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-264" data-mp="1ccmyqfi0999x" />}
    </button>;
}